import React,{useState} from "react";

import ModuleHeader from "../components/ModuleHeader";

import {useIdea} from "../context/IdeaContext";

import {useAuth} from "../context/AuthContext";

import IdeaPopup from "./IdeaPopup";

const CommunityProgress=()=>{

const {selectedIdea,businessModel}=useIdea();

const {user}=useAuth();

/* ================= STARTUP RESOLVER ================= */

const startupName=

selectedIdea?.ideaTitle ||

selectedIdea?.title ||

businessModel?.startupName ||

localStorage.getItem("activeIdeaTitle") ||

"Startup Idea";

/* ================= USER ================= */

const founderName=

user?.name ||

user?.fullName ||

"Founder";

/* ================= STATE ================= */

const[showPopup,setShowPopup]=useState(false);

const[popupPayload,setPopupPayload]=useState(null);

/* ================= CTA ================= */

const reserveAccess=()=>{

setPopupPayload({

idea:{title:"Founder Community"},

type:"progress",

aiMessageOverride:
"You are now part of the early founder group. Community access will open soon."

});

setShowPopup(true);

setTimeout(()=>{

setShowPopup(false);

},3200);

};


/* ================= UI ================= */

return(

<div className="bg-slate-50 min-h-screen">

<div className="max-w-6xl mx-auto px-6 py-10">

{showPopup && popupPayload &&(

<div className="fixed bottom-5 right-5 z-50">

<IdeaPopup {...popupPayload} autoClose/>

</div>

)}

<ModuleHeader

title="Founder Community"

subtitle="Connect with serious builders and grow faster together."

currentModule="community"

startup={startupName}

badges={[

"Founder Network",

"Early Builders",

"Coming Soon"

]}

/>


{/* ACTIVE IDEA */}

<div className="text-sm text-gray-500 border-b border-slate-200 pb-4 mb-6">

<b>Startup:</b> {startupName}

</div>


{/* HERO */}

<div className="bg-gradient-to-r from-indigo-50 to-blue-50 border rounded-2xl p-10 text-center">

<h2 className="text-3xl font-semibold text-blue-900">

🌐 Founding Builders Network Forming

</h2>

<p className="text-slate-600 mt-4 max-w-2xl mx-auto">

{founderName}, you are among the early founders building on this platform.

We are bringing together serious builders focused on execution, not just ideas.

</p>

<p className="text-slate-600 mt-4 max-w-2xl mx-auto">

Access to the community will open soon and early founders like you will receive priority invitations.

</p>

<button

onClick={reserveAccess}

className="mt-8 bg-indigo-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-indigo-700"

>

Reserve Founder Access →

</button>

<div className="mt-4 text-sm text-slate-500">

Early founders get priority entry.

</div>

</div>


{/* BENEFITS */}

<div className="mt-10 border rounded-2xl p-8 bg-white">

<h3 className="text-xl font-semibold text-slate-800 text-center">

What Founders Will Unlock

</h3>

<div className="mt-6 grid md:grid-cols-2 gap-4 text-sm text-slate-600">

<div>🚀 Connect with execution-focused founders</div>

<div>🤝 Find collaborators and co-builders</div>

<div>💡 Get product feedback from real builders</div>

<div>🎯 Join startup challenges</div>

<div>📈 Share traction milestones</div>

<div>🔥 Private founder discussions</div>

</div>

</div>


{/* FOUNDER PSYCHOLOGY */}

<div className="mt-10 border rounded-2xl p-8 bg-white text-center">

<h3 className="text-xl font-semibold text-slate-800">

You are already ahead of most builders.

</h3>

<p className="text-slate-600 mt-3 max-w-xl mx-auto">

Most people stay stuck at the idea stage.

You are actively building your startup.

Early builders always gain the biggest advantage when communities open.

</p>

<div className="mt-6 text-blue-600 font-medium">

Keep building. Your progress will unlock founder advantages.

</div>

</div>


{/* FUTURE FEATURES */}

<div className="mt-10 border rounded-xl p-6 bg-white">

<h3 className="text-lg font-semibold text-slate-800">

🚀 Community Features Coming Soon

</h3>

<div className="mt-4 grid md:grid-cols-2 gap-3 text-sm text-slate-600">

<div>Founder discussion rooms</div>

<div>Startup team formation</div>

<div>Peer startup reviews</div>

<div>Founder cohorts</div>

<div>Investor AMA sessions</div>

<div>Startup leaderboard</div>

</div>

</div>


{/* MOTIVATION CTA */}

<div className="mt-10 text-center border rounded-2xl p-8 bg-gradient-to-r from-blue-50 to-indigo-50">

<h3 className="text-xl font-semibold text-slate-800">

Stay consistent. Builders win.

</h3>

<p className="text-slate-600 mt-2">

Continue progressing through your startup journey to unlock early founder advantages.

</p>

<button

onClick={reserveAccess}

className="mt-6 bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700"

>

Get Founder Priority Access →

</button>

</div>


</div>

</div>

);

};

export default CommunityProgress;